// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Xv-z","tooltipWrapper":"Yv-z","icon":"Zv-z","tooltip":"_v-z","content":"aw-z"};